export const ALL = "all";
export const COGS = "cogs";
export const BULK_UPDATE_COGS = "bulk_update_cogs";
